import { Formik, Form } from "formik";
import { useState } from "react";
import { Button, Col, Row } from "reactstrap";
import * as Yup from "yup";
import { newUserAction } from "../../../redux/actions/auth/auth.actions";
import { useDispatch } from "react-redux";
import { MdEmail } from "react-icons/md";
import { IoMdLock } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import OtpModel from "../../../components/OtpModel";
import ReactGA from 'react-ga4';
import { useTranslation } from "react-i18next";
// import appsflyer from 'appsflyer-web-sdk';
ReactGA.initialize('G-D3Y4J4RSR8');

const Signup = ({ setresMsg }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [passwordShown, setPasswordShown] = useState(false);
  const [selectedType, setSelectedType] = useState(false);
  const [otpModal, setOTPModal] = useState(false);
  const dispatch = useDispatch();

  const defaultValues = {
    email: "",
    password: "",
  };
  //Schema for Error Formik
  const SignupSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email format").required("Required"),
    password: Yup.string().required(),
  });

  // Payload to send
  const payloadObj = {
    email: "",
    password: "",
    type: 0,
  };

  const payloadObjfunc = (values) => {
    let email = values?.email.toLowerCase()
    payloadObj.type = selectedType;
    payloadObj.password = values.password;
    payloadObj.email = email;
  };

  const handleSubmit = (fdata) => {
    // setresMsg("")
    payloadObjfunc(fdata);
    dispatch(newUserAction(payloadObj))
      .then((res) => {
        console.log(res.user.status);
        ReactGA.event({
          category: 'User',
          action: 'Create Signup',
          label: 'Signup',
        });
        window.clarity("set", "page", "SignUp");
        if (res.user.status === 200) {
          // appsflyer.logEvent("signUp", {userName: fdata?.firstName + " " + fdata?.lastName, accountType: fdata.bsType});
          setresMsg(res?.user?.message);
          setOTPModal(!false)

        } else {
          setresMsg(res?.user?.message);
        }
      });
  };
  function signUpPageChange() {
    navigate("/login")
  }
  return (
    <>
      <Formik
        initialValues={defaultValues}
        onSubmit={handleSubmit}
        validationSchema={SignupSchema}
      >
        {({
          values,
          errors,
          handleChange,
          handleSubmit,
          touched,
          isValid,
          dirty,
        }) => (
          <Form onSubmit={handleSubmit} autoComplete="off">

            <div style={{ marginTop: 5, marginHorizontal: 15 }}>
              <div className="d-flex justify-content-center gap-2 mb-3 w-100">
                <div
                  className="accountCard" title="For individual use — connect with friends"
                  style={selectedType ? null : { backgroundColor: '#6148a1' }}
                  onClick={() => setSelectedType(false)}
                >
                  <div className="cardBody text-center">
                    <p className="">👤</p>
                    <p className="" style={selectedType ? null : { color: '#fff' }}>Personal Account</p>
                  </div>
                </div>

                <div
                  className="accountCard" title="Promote your business with a dedicated page"
                  style={selectedType ? { backgroundColor: '#6148a1' } : null}
                  onClick={() => setSelectedType(true)}
                >
                  <div className="cardBody text-center">
                    <p className="">🏢</p>
                    <p className="" style={selectedType ? { color: '#fff' } : null}>Business Account</p>
                  </div>
                </div>
              </div>
            </div>

            {/* ////////////// Email & Pass ///////////////// */}
            <Row>
              <Col lg="12" md="12" sm="12" xs="12"></Col>
              <Col lg="12" md="12" sm="12" xs="12">
                <div className="mt-3 position-relative px-4">
                  <label className="Label">{t('email')}</label>
                  <MdEmail className="Mdinfo" color="black" size={20} />
                  <input
                    className="form-control input-btn padd"
                    name="email"
                    onChange={handleChange}
                    value={values.email}
                    autoComplete="off"
                    type={"email"}
                    placeholder={t("email")}
                  />
                </div>
              </Col>
              <Col lg="12" md="12" sm="12" xs="12">
                <div className="mt-3 position-relative px-4">
                  <label className="Label">{t('password')}</label>
                  <IoMdLock className="IoMdLock" color="black" size={20} />
                  <input
                    className="form-control input-btn padd"
                    value={values.password}
                    name="password"
                    type={passwordShown ? "text" : "password"}
                    placeholder={t("password")}
                    onChange={handleChange}
                  />
                  {passwordShown === true ?
                    <AiFillEye onClick={() => setPasswordShown(false)} className="eyeInvisible" color="black" size={20} /> :
                    <AiFillEyeInvisible onClick={() => setPasswordShown(true)} className="eyeInvisible" color="black" size={20} />
                  }
                </div>
              </Col>
              {/* Button */}
              <Col lg="12" md="12" sm="12" xs="12" className="d-flex justify-content-center p-4 pb-3">
                <Button
                  type="submit"
                  className="submit-btn ib-btn w-100 mx-2"
                  disabled={!(dirty && isValid)}
                  onClick={() => {
                    document.documentElement.scrollTop = 0;
                  }}
                >
                  {t('continue')}
                </Button>
              </Col>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <p className="dontHave">{t('alreadyAccount')}</p>
                <Button className="signup_button" onClick={signUpPageChange}>
                  <b>{t('signIn')}</b>
                </Button>
              </div>
            </Row>
          </Form>
        )}
      </Formik>
      {otpModal && <OtpModel setOTPModal={(() => setOTPModal(!otpModal))} otpModal={otpModal} setError={''} />}
    </>

  );
};

export default Signup;